const $ = window.jQuery;

$(() => {
    $('.select__lng').on('change', function(e) {
        window.location.href = $(this).val();
    });
});
